import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const Memberlist = createAsyncThunk(
    'membership/Memberlist',
    async (data) => {
        let url = baseUrl+'MembershipPlan';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const UpgradePlan = createAsyncThunk(
    'membership/UpgradePlan',
    async (data) => {
        let url = baseUrl+'UpgradePlan';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
               Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else if(response.status === "error") {
            return Promise.resolve(response)
        }else{
          return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  export const DegradePlan = createAsyncThunk(
    'membership/DegradePlan',
    async (data) => {
        let url = baseUrl+'DegradePlan';
        const token=Cookies.get("token");
      try {
        const response = (await axios.post(url,data,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const MembershipPlanList = createAsyncThunk(
    'MembershipPlanList',
    async () => {
        let url = baseUrl+'membershipPlanList';
      try {
        const response = (await axios.get(url))
        // console.log(response,"response")
        if(response?.data?.status === "success"){
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );


  